import React, { useEffect } from 'react';
import Contact from '../components/Contact';
const StartAProject = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="mt-24 xl:mt-2">
            <div>
                <Contact />
                <div className='mt-48'/>
            </div>
        </div>
    );
};

export default StartAProject;
